import { FragmentRESTSerializer as RESTSerializer } from 'ember-data-model-fragments/serializer';

export default class Group extends RESTSerializer {
  payloadKeyFromModelName(modelName) {
    let model = super
      .payloadKeyFromModelName(modelName)
      .replace(/^groups\//, '');
    return model + 'Template';
  }

  modelNameFromPayloadKey(key) {
    return super.modelNameFromPayloadKey(key.replace(/Template/i, ''));
  }
}
